import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useRequestData } from 'wsm-common-data';

const Select = ({
	data,
	inputType,
	itemIndex,
	selected,
	handleSelect,
	detail,
	sideContent,
	labelClasses = ''
}) => {
	const { deviceType } = useRequestData();
	const isDesktop = deviceType === 'DESKTOP';
	const deviceClassesOuter = isDesktop ? 'border-bottom' : 'my-3';
	const defaultHoverClass = isDesktop ? 'border-page-title' : '';
	const [itemHoverClass, setItemHoverClass] = useState(defaultHoverClass);

	const onHover = (isHover) => {
		const className = isHover ? 'border-dark' : defaultHoverClass;
		setItemHoverClass(className);
	};

	return (
		<React.Fragment>
			<div
				className={`text-left ${deviceClassesOuter}`}
				data-testid={`select-container-${data.id}`}
			>
				<label
					htmlFor={`${data.id}_input`}
					data-testid={`select-label-${data.id}`}
					className={`font-weight-normal d-flex w-100 border rounded p-5 my-4 ${labelClasses} ${
						selected ? 'border-info' : itemHoverClass
					}`}
					onMouseEnter={() => onHover(true)}
					onMouseLeave={() => onHover(false)}
				>
					<input
						type={inputType}
						className="mt-0 mr-4"
						id={`${data.id}_input`}
						value={data.id}
						checked={selected}
						onChange={(e) => handleSelect(e, itemIndex)}
					/>
					<div className="d-flex flex-column ml-3 justify-content-center">
						<div className="">{data.value}</div>
						{detail && (
							<small className="text-muted">{detail}</small>
						)}
					</div>
					{sideContent && (
						<div
							style={{ marginLeft: 'auto' }}
							className="d-flex align-items-center"
						>
							{sideContent}
						</div>
					)}
				</label>
			</div>
		</React.Fragment>
	);
};

Select.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			globalVehicleTrimId: PropTypes.string.isRequired,
			startingAtPrice: PropTypes.number.isRequired,
			trim: PropTypes.string.isRequired
		})
	),
	inputType: PropTypes.string.isRequired,
	itemIndex: PropTypes.number.isRequired,
	selected: PropTypes.bool.isRequired,
	handleSelect: PropTypes.func.isRequired,
	detail: PropTypes.string,
	sideContent: PropTypes.element,
	labelClasses: PropTypes.string
};

export default Select;
